import React, { useEffect, useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Select, Checkbox } from "antd";
import { useParams } from "react-router-dom";
import useGetApi from "../../services/useGetApi";
import usePost from "../../services/usePost";
// import FileUploader from "../../../components/fileUploader/FileUploader";


const UpdateLesson = ({ updateLessonBtn, setUpdateLessonBtn, lessonEditId,loadSections}) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [sectionSelect, setSectionSelect] = useState([]);
  const [isPostLoading, postError, postData] = usePost();
  const [addLesson, setAddLesson] = useState({});

  const [
    lessonIsLoading,
    lessonError,
    lesson,
    getLesson,
  ] = useGetApi(`lessons/${lessonEditId}`, [], true);

  const [
    sectionIsLoading,
    sectionError,
    sections,
    getSections,
  ] = useGetApi(`course/details/${id}`, [], true);

  useEffect(() => {
    getSections(`course/details/${id}`);
  }, [id]);

  useEffect(() => {
    getLesson(`lessons/${lessonEditId}`);
  }, [lessonEditId]);

  useEffect(() => {
    if (sections) {
      const formattedOptions = sections?.sections?.map((section) => ({
        value: section.id,
        label: section.title,
      }));
      setSectionSelect(formattedOptions);
    }
  }, [sections]);

  // Set initial form values when the lesson data is available
  useEffect(() => {
    if (lesson) {
      setAddLesson(lesson)
      form.setFieldsValue({
        title: lesson.title,
        section: lesson.sectionId,
        videoUrl: lesson.videoUrl,
        duration: lesson.duration,
        videoUrlForMobileApplication: lesson.videoUrlForMobileApplication,
        durationForMobileApplication: lesson.durationForMobileApplication,
        summary: lesson.summary,
        isFreeLesson: lesson.isFree === 1,
      });

    }
  }, [lesson]);

  const handleFormSubmit = async() => {

   const response = await postData(`lessons`, addLesson, true); 
   if(response){
    // console.log('success')
    loadSections(`course/details/${id}`)
    setUpdateLessonBtn(false)
   }
  };

  const handleImageUpload = (filePath) => {
    // setData((prev) => ({
    //   ...prev,
    //   imageUrl: filePath,
    // }));

    setAddLesson({ ...addLesson, videoUrl: filePath })

    console.log(filePath,'filfeilefilefile')
  };


  // useEffect(() =>{
  //   console.log(addLesson,'.....................')
  // },[addLesson])

  return (
    <div>
      {updateLessonBtn && (
        <div className="popup-overlay" style={{marginTop:'20px'}}>
          <div className="addlesson-popup-container p-20">
            <Row gutter={16}>
              <Col span={12}>
                <h5>Update lesson</h5>
              </Col>
              <Col span={12}>
                <button className="close-btn" onClick={() => setUpdateLessonBtn(false)}>
                  <CloseOutlined />
                </button>
              </Col>
            </Row>

            <Row className="popup_horizontal_line"></Row>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleFormSubmit}
            >
              <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please input the title!" }]}
              >
                <Input placeholder="Enter title" 
                  onChange={(e) => setAddLesson({...addLesson,title:e.target.value})}
                />
              </Form.Item>

              <Form.Item
                label="Section"
                name="section"
                rules={[{ required: true, message: "Please select a section!" }]}
              >
                <Select
                  options={sectionSelect}
                  placeholder="Select section"
                  className="w-100"
                />
              </Form.Item>

              <Form.Item
                label="Video Url (For web application)"
                name="videoUrl"
                rules={[{ required: true, message: "Please input the video URL!" }]}
              >
                {/* <Input placeholder="Enter video URL" 
                  onChange={(e) => setAddLesson({...addLesson,videoUrl:e.target.value})}
                /> */}
                    {
                        (addLesson?.lessonType === "YouTube Video" || addLesson?.lessonType === "Vimeo Video" || addLesson?.lessonType === "Iframe embed") 
                        ? <Input
                            value={addLesson.videoUrl}
                            onChange={(e) => setAddLesson({ ...addLesson, videoUrl: e.target.value })}
                          />
                        : 
                         <div>
                           {/* <FileUploader
                              onImageUpload={handleImageUpload}
                              subdir="lessons"
                              fileName={addLesson.videoUrl}
                           /> */}
                           file upload
                         </div>
                      
                    }
              </Form.Item>

              <Form.Item
                label="Duration (For web application)"
                name="duration"
                rules={[{ required: true, message: "Please input the duration!" }]}
              >
                <Input placeholder="Enter duration" 
                 onChange={(e) => setAddLesson({...addLesson,duration:e.target.value})}
                />
              </Form.Item>

              {/* <Form.Item
                label="Video Url (For mobile application)"
                name="videoUrlForMobileApplication"
                rules={[{ required: true, message: "Please input the video URL!" }]}
              >
                <Input placeholder="Enter mobile video URL" 
                  onChange={(e) => setAddLesson({...addLesson,videoUrlForMobileApplication:e.target.value})}
                />
              </Form.Item>

              <Form.Item
                label="Duration (For mobile application)"
                name="durationForMobileApplication"
                rules={[{ required: true, message: "Please input the duration!" }]}
              >
                <Input placeholder="Enter mobile duration" 
                  onChange={(e) => setAddLesson({...addLesson,durationForMobileApplication:e.target.value})}
                />
              </Form.Item> */}

              <Form.Item
                label="Summary"
                name="summary"
                rules={[{ required: true, message: "Please input the summary!" }]}
              >
                <Input.TextArea placeholder="Enter lesson summary" 
                  onChange={(e) => setAddLesson({...addLesson,summary:e.target.value})}
                />
              </Form.Item>

              <Form.Item name="isFreeLesson" valuePropName="checked">
                <Checkbox>Mark as free lesson</Checkbox>
              </Form.Item>

              <button className="popup_update_lesson_btn"
                 htmlType="submit"
              >
                Update Lesson
              </button>
            </Form>

            <Row className="popup_horizontal_line"></Row>

            <Row className="back_btn_div mt-10">
              <button className="popup_back_btn" onClick={() => setUpdateLessonBtn(false)}>
                Back
              </button>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateLesson;
